import { render, staticRenderFns } from "./FullscreenTabs.vue?vue&type=template&id=d9c59e80&"
import script from "./FullscreenTabs.vue?vue&type=script&lang=js&"
export * from "./FullscreenTabs.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports